import { Flex, Text } from '@mantine/core';
import React, { useEffect, useState } from 'react';
import Card from '../../components/elements/Card';
import CollapseRaterInput from '../../components/fragments/CollapseRaterInput';
import { raterDataType } from '../rater_form_detail';
import Button from '../../components/elements/Button';
import { FiSave } from 'react-icons/fi';
import { useForm } from 'react-hook-form';
import { createSchema } from './validation';
import { yupResolver } from '@hookform/resolvers/yup';

export interface RaterData {
  raterID: string;
  title: string;
  jenis: string;
  dateIn: string;
  dateUp: string | null;
  userIn: string;
  userUp: string | null;
  isDeleted: boolean;
  scoreRater: number | null;
  scoreExpectation: number | null;
}

interface RaterInputFormProps {
  questions: RaterData[];
  type: 'rater' | 'expectation';
  onSubmit: (payload: any) => void;
}

const RaterInputForm: React.FC<RaterInputFormProps> = ({
  questions,
  type,
  onSubmit
}) => {
  const [dataRater, setDataRater] = useState(null);
  // Inside your component
  const [schema, setSchema] = useState(null);

  useEffect(() => {
    if (questions && questions.length > 0) {
      const grouped = questions.reduce((acc, item) => {
        const key = item.jenis;
        if (raterDataType.includes(key)) {
          acc[key].push(item);
        }
        return acc;
      }, Object.fromEntries(raterDataType.map((jenis) => [jenis, []])));

      setDataRater(grouped);
    }
  }, [questions]);

  useEffect(() => {
    if (dataRater) {
      const schemeMod = createSchema(dataRater);
      setSchema(schemeMod);
    }
  }, [dataRater]);

  const {
    control,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onBlur',
    resolver: schema ? yupResolver(schema) : undefined
  });

  const handleSubmitForm = (values) => {
    const notes = [
      'Reliability-notes',
      'Assurance-notes',
      'Tangibles-notes',
      'Empathy-notes',
      'Responsiveness-notes'
    ];
    const modDetail: { raterID: string; point: number }[] = [];
    const modNotes: { jenis: string; notes: string }[] = [];

    const getJenisKey = (jenis: string) => {
      switch (jenis) {
        case 'Reliability':
          return 'R1';
        case 'Assurance':
          return 'A';
        case 'Tangibles':
          return 'T';
        case 'Empathy':
          return 'E';
        case 'Responsiveness':
          return 'R2';
        default:
          break;
      }
    };

    Object.keys(values).forEach((key) => {
      const isNotes = notes.includes(key);
      if (!isNotes) {
        modDetail.push({
          raterID: key,
          point: Number(values[key])
        });
      }

      if (isNotes) {
        modNotes.push({
          jenis: getJenisKey(key.split('-')[0]),
          notes: values[key] || ''
        });
      }
    });

    onSubmit({ detail: modDetail, notes: modNotes });
  };

  return (
    <Flex direction={'column'} gap={16}>
      <Flex justify="center" align="center">
        <Text fz={14} fw={500}>
          {type === 'rater' ? 'RATER' : 'EXPECTATION'} QUESTIONS USING{' '}
          <strong>R.A.T.E.R</strong> METHOD
        </Text>
      </Flex>

      <form onSubmit={handleSubmit((data) => handleSubmitForm(data))}>
        <Flex direction={'column'} gap={16}>
          {dataRater &&
            raterDataType.map((item, index) => {
              const sortedData = dataRater[item].sort(
                (a, b) => a.nomor - b.nomor
              );
              return (
                <Card key={index}>
                  <CollapseRaterInput
                    title={item}
                    control={control}
                    data={sortedData}
                    errors={errors}
                    type={type}
                  />
                </Card>
              );
            })}

          <Flex justify="flex-end" align="center">
            <Button
              disabled={!isValid}
              leftSection={<FiSave size={16} />}
              type="submit"
            >
              Submit
            </Button>
          </Flex>
        </Flex>
      </form>
    </Flex>
  );
};

export default RaterInputForm;
